import { render, staticRenderFns } from "./ActionbarList.vue?vue&type=template&id=463367d7&"
import script from "./ActionbarList.vue?vue&type=script&lang=ts&"
export * from "./ActionbarList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports